import React from 'react';
import { st, classes } from './RichTextToolbarButton.st.css.js';
import Tooltip from '../../Tooltip';
const RichTextToolbarButton = ({ dataHook, onClick, tooltipText, isActive, isDisabled, children, }) => (React.createElement(Tooltip, { content: tooltipText },
    React.createElement("button", { type: "button", "data-active": isActive, "data-hook": dataHook, className: st(classes.button, {
            disabled: isDisabled,
            active: !isDisabled && isActive,
        }), onClick: isDisabled ? undefined : onClick }, children)));
export default RichTextToolbarButton;
//# sourceMappingURL=RichTextToolbarButton.js.map